import type {ForgotPasswordPageProps} from 'src/types/authentication';

import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {useHistory} from 'src/rerouter';

import {CONSTANTS} from 'src/components/authentication/contants';

import ForgotPassword from 'src/components/referrer-portal/authentication/forgot/forgot-password/forgot-password';
import ForgotPasswordConfirmation from 'src/components/authentication/forgot/forgot-confirmation/forgot-confirmation';
import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import css from './forgot-container.css';
import maincss from 'src/components/authentication/main.css';


const ForgotPasswordContainer = () => {
  const {t, makeKey} = useLabelTranslation();
  const router = useHistory();
  const [curPage, setCurPage] = React.useState<string>('');

  const showConfirmation = () => {
    setCurPage('RESET_CONFIRMATION');
  };

  const handleBackBtnClick = () => {
    router.replace('/signin');
  };

  const getContent = () => {
    switch (curPage) {
      case 'RESET_CONFIRMATION':
        return <ForgotPasswordConfirmation />;
      default:
        return <ForgotPassword showConfirmation={showConfirmation} />;
    }
  };

  return (
    <div className={maincss.contentSideBar}>
      <Button
        iconLeftName="angle-left"
        onClick={handleBackBtnClick}
        size="medium"
        type="tertiary"
      >
        {t(makeKey(CONSTANTS.BACK_BUTTON_TEXT), CONSTANTS.BACK_BUTTON_TEXT)}
      </Button>

      <div className={css.containerContent}>
        <div className={css.resetSection}>{getContent()}</div>
      </div>
    </div>
  );
};

export default ForgotPasswordContainer;
